import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoBreadcrumbModule, PoModalModule, PoPageModule, PoButtonModule, PoContainerModule, PoFieldModule, PoTableModule, PoWidgetModule, PoLoadingModule, PoInputComponent, PoModalComponent, PoModalAction } from '@po-ui/ng-components';
import { BarcodeReaderComponent } from '../../../../shared/components/barcode-reader/barcode-reader.component';
import { INVENTORY_STATUS } from '../../../../constants';
import { InventoryService } from '../../../../shared/service/inventory.service';
import { TokenService } from '../../../../shared/service/token.service';
import { ToasterService } from '../../../../shared/service/toaster.service';
import { AudioService } from '../../../../shared/service/audio.service';
import { InventoryCountModel } from '../../../../models/inventory-count.model';
import { InventoryModel } from '../../../../models/inventory.model';
import { InventoryCountItemModel } from '../../../../models/inventory-count-item.model';
import { ProductModel } from '../../../../models/product.model';
import { disableKeyboardInput } from '../../../../shared/components/utils';
import { InventoryCountDetailLastCountedCardComponent } from './inventory-count-detail-last-counted-card/inventory-count-detail-last-counted-card.component';
import { InventoryLastCountedModel } from '../../../../models/inventory-last-counted.model';

@Component({
  selector: 'app-inventory-count-detail',
  imports: [
    PoBreadcrumbModule,
    PoModalModule,
    CommonModule,
    PoPageModule,
    PoButtonModule,
    PoContainerModule,
    PoFieldModule,
    PoTableModule,
    PoWidgetModule,
    FormsModule,
    ReactiveFormsModule,
    PoLoadingModule,
    BarcodeReaderComponent,
    InventoryCountDetailLastCountedCardComponent],
  templateUrl: './inventory-count-detail.component.html',
  styleUrl: './inventory-count-detail.component.css'
})
export class InventoryCountDetailComponent implements AfterViewInit {
  @Output() isLoading = new EventEmitter<boolean>();
  @Input() InventoryModel!: InventoryModel;
  @Input() inventoryCountModel!: InventoryCountModel;
  @Output() onCountFinished = new EventEmitter();
  @ViewChild('productInput') productInput!: PoInputComponent;
  @ViewChild('poModalListItens', { static: false }) poModalListItens!: PoModalComponent;
  @ViewChild('poModalConfirmFinish', { static: false }) poModalConfirmFinish!: PoModalComponent;
  @ViewChild('barCodeReader', { static: false }) barCodeReader!: BarcodeReaderComponent;
  @ViewChild('modalBarCodeReader', { static: false }) modalBarCodeReader!: PoModalComponent;
  @ViewChild('countCard') countCardDiv!: ElementRef<HTMLDivElement>;

  inventoryStatus = '';
  inventoryCountItems: InventoryCountItemModel[] = [];
  listAllItems: any[] = [];
  lastCountedList: InventoryLastCountedModel[] = [];

  secondaryActionBarCodeReader: PoModalAction = {
    action: () => {
      this.barCodeReader.turnOff();
    },
    label: 'Sair'
  };

  primaryAction: PoModalAction = {
    action: () => {
      this.poModalConfirmFinish.close();
      this.finish();
    },
    label: 'Sim'
  };
  secondaryAction: PoModalAction = {
    action: () => {
      this.poModalConfirmFinish.close();
    },
    label: 'Não'
  };

  seeDescriptionItens: boolean = false;
  productCodeInput: string = '';
  inventoryCode: number = 0;
  inventorySequence: number = 0;
  inventoryStatusInProgress = 1;
  countedItems = 0;

  constructor(
    private inventoryService: InventoryService,
    private tokenService: TokenService,
    private toasterService: ToasterService,
    private audioService: AudioService
  ) { }

  ngAfterViewInit(): void {
    this.inventoryStatus = INVENTORY_STATUS.find(status =>
      status.value === this.InventoryModel.inventoryStatus
    )?.label ?? 'Desconhecido';

    this.loading(true);
    this.getInventoryCountItems(true);
  }

  scrollToInPageProductInput() {
    const wrapper = document.querySelector('.po-page-content');
    const productInputElement = this.productInput?.inputEl?.nativeElement as HTMLElement;

    if (wrapper && productInputElement && this.countCardDiv) {
      const wrapperRect = wrapper.getBoundingClientRect();
      const divRect = this.countCardDiv.nativeElement.getBoundingClientRect();

      const offsetTop = divRect.top - wrapperRect.top + wrapper.scrollTop;

      setTimeout(() => {
        wrapper.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });

        productInputElement.focus({ preventScroll: true });

        this.loading(false);
      }, 500);
    } else {
      this.loading(false);
      this.productInput.focus();
    }
  }

  disableKeyboard() {
    const input = document.querySelector('input.po-input[name="inputBarcode"]') as HTMLInputElement;
    disableKeyboardInput(input);
  }

  getInventoryCountItems(afterViewInit: boolean = false) {
    const loggedBranchCode = this.tokenService.getBranch();
    this.inventoryService.getInventoryCountItemsList(Number(loggedBranchCode), this.InventoryModel.inventoryCode, this.inventoryCountModel.inventoryCountCode)
      .subscribe({
        next: (data) => {
          this.inventoryCountItems = data.items;
          this.updateCountedItems();
          this.getLastCountedProducts();
          if (afterViewInit) {
            this.scrollToInPageProductInput();
          }
        },
        error: () => {
          this.toasterService.triggerAlert('Não foi possível obter os itens da contagem', 'error');
          if (afterViewInit) {
            this.scrollToInPageProductInput();
          }
        }
      });
  }

  getLastCountedProducts() {
    const lastCountsFlattened = this.inventoryCountItems.flatMap(item =>
      item.lastCounts.map(count => ({
        productCode: item.productCode,
        description: item.productDescription,
        date: new Date(count.countData)
      }))
    );

    const sorted = lastCountsFlattened.sort((a, b) => b.date.getTime() - a.date.getTime());

    const top3 = sorted.slice(0, 3);

    this.lastCountedList = top3.map(p => ({
      productCode: p.productCode,
      description: p.description,
      date: p.date
    }));
  }

  seeDescription() {
    this.seeDescriptionItens = !this.seeDescriptionItens;
  }

  loading(value: boolean) {
    this.isLoading.emit(value);
  }

  onCountProductCode() {
    if (this.productCodeInput.trim() == '') {
      this.productCodeInput = '';
      this.productInput.focus();
      return;
    }

    this.addProduct();
  }

  onReadBarcodeReader(event: any) {
    this.productCodeInput = event;
    this.addProduct();
  }

  addProduct() {
    this.inventoryService
      .getProduct(this.productCodeInput.trim(), this.inventoryCountModel.branchCode)
      .subscribe({
        next: (data) => {
          this.countProduct(data.items[0]);
        },
        error: (error: any) => {
          this.toasterService.triggerAlert(`Produto ${this.productCodeInput} não encontrado`, 'error');
          this.productCodeInput = '';
          this.productInput.focus();
        }
      })
  }

  countProduct(product: ProductModel) {
    var countItem = this.inventoryCountItems.find((countItem) => countItem.productCode === product.productCode);

    if (!countItem) {
      this.toasterService.triggerAlert(`Produto ${product.productCode} não pertence ao balanço ${this.InventoryModel.inventoryCode}`, 'error');
      this.productCodeInput = '';
      this.productInput.focus();
      return;
    }

    const loggedBranchCode = this.tokenService.getBranch();
    const productQuantity = 1;
    const barCode = product.isRfid ? this.productCodeInput : product.productSku;
    const rfid = product.isRfid ? this.productCodeInput : null;
    this.inventoryService
      .postCountInventoryItem(Number(loggedBranchCode), this.inventoryCountModel.inventoryCode, this.inventoryCountModel.inventoryCountCode, product.productCode, productQuantity, barCode, rfid)
      .subscribe({
        next: (data) => {
          this.productCodeInput = '';
          this.productInput.focus();
          this.getInventoryCountItems();
          this.audioService.playBeep(1);
        },
        error: (error: any) => {
          var message = error?.error[0]?.message ?? `Não foi possível contar o produto ${this.productCodeInput}`;
          this.toasterService.triggerAlert(message, 'error');
          this.productCodeInput = '';
          this.productInput.focus();
        }
      });
  }

  startBarCodeReader() {
    this.modalBarCodeReader.open();
    this.barCodeReader.start();
  }

  turnOffBarcodeReader() {
    this.modalBarCodeReader.close();
  }

  updateCountedItems() {
    this.countedItems = this.inventoryCountItems.reduce((acc, item) => acc + item.countQuantity, 0);
  }

  openItemsModal() {
    this.listAllItems = this.inventoryCountItems.filter((item) => item.countQuantity > 0).map((item) => ({
      'COD': item.productCode.toString(),
      'DES': item.productDescription,
      'GRP': item.groupCode,
      'QTD': item.countQuantity,
      'LOCAL': item.localDescription
    }));
    this.poModalListItens.open();
  }

  finish() {
    this.inventoryService.postFinalizeInventoryCount(Number(this.tokenService.getBranch()), this.inventoryCountModel.inventoryCode, this.inventoryCountModel.inventoryCountCode)
      .subscribe({
        next: (data) => {
          this.onInventoryCountFinished();
        },
        error: (error: any) => {
          this.toasterService.triggerAlert(`Não foi possível finalizar a contagem.`, 'error');
        }
      });
  }

  onInventoryCountFinished() {
    this.toasterService.triggerAlert(`Contagem finalizada com sucesso.`, 'success');
    this.onCountFinished.emit();
  }
}
